import React, { useState } from 'react';
import axios, { AxiosError } from 'axios';
import { FaUser, FaEnvelope, FaLock } from 'react-icons/fa';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from 'react-router-dom';

const Register: React.FC = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '', address: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        'https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/AdminSignUp/AdminSignUp',
        {
          name: form.name,
          email: form.email,
          password: form.password
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      console.log('✅ Registered successfully:', response.data);
      toast.success('🎉 Registered successfully!');
      setForm({ name: '', email: '', password: '', phone: '', address: '' }); // Reset form
    } catch (err) {
      const axiosError = err as AxiosError;
      console.error('❌ Registration error:', axiosError.message);
      toast.error('❌ Failed to register. Please try again.');
    }
  };

  return (
    <div className="auth-bg d-flex justify-content-center align-items-center min-vh-100" style={{
      background: "linear-gradient(to right, #f3f3f3, #e0ffe0)",
      backgroundImage: `url('/images/ppbg.jpg')`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }}>
      <div
        className="card shadow-lg p-5 rounded-4 bg-white"
        style={{
          width: "100%",
          maxWidth: "450px",
          maxHeight: "90vh",
          overflowY: "scroll",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div className="text-center mb-4">
          <img src="/images/fhome-logo.jpg" alt="Logo" style={{ height: 60, width: 80 }} />
          <h4 className="mt-3 fw-bold">Create Your Account</h4>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label><FaUser className="me-2" /> Name</label>
            <input
              type="text"
              name="name"
              className="form-control rounded-3"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group mb-3">
            <label><FaEnvelope className="me-2" /> Email</label>
            <input
              type="email"
              name="email"
              className="form-control rounded-3"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group mb-4">
            <label><FaLock className="me-2" /> Password</label>
            <input
              type="password"
              name="password"
              className="form-control rounded-3"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            {/* Your routes or main layout */}
            <ToastContainer
              position="top-right"    // position of toast
              autoClose={3000}        // auto close in 3s
              hideProgressBar={false} // show/hide progress bar
              newestOnTop={false}
              closeOnClick
              pauseOnHover
              draggable
              theme="colored"         // optional: "light" | "dark" | "colored"
            />
          </div>
          <button type="submit" className="btn btn-primary w-100 py-2 rounded-3">Sign Up</button>
        </form>
        <p className="text-center mt-3 mb-0">
          Already a member? <Link to="/login" className="text-decoration-none">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;

